import * as React from "react";

import { Modal } from "antd";

const EarnGoldCheckModal = ({ show, setShow }) => {
	return (
		<Modal
			title=""
			open={show}
			footer={null}
			closable={false}
			wrapClassName="modal-wrap seller-grade-modal-wrap custom-modal-wrap"
			width={400}
			centered={true}
		>
			<div
				className="modal-title"
				style={{ width: "60%", wordBreak: "keep-all" }}
			>
				100,000 Gold 이상의 Gold를 입력하시거나 보유 Gold를 확인해주세요.
			</div>
			<div className="modal-button-wrap">
				<div className="modal-button-success" onClick={() => setShow(false)}>
					확인
				</div>
			</div>
		</Modal>
	);
};

export default EarnGoldCheckModal;
